import styled, { css } from 'styled-components';
import { GrowthLevelIndicator as _GrowthLevelIndicator } from 'src/components';

export const SummaryContainer = styled.div(
  ({ theme }) => css`
    border-radius: ${theme.bo.mediumSmall};
    background-color: ${theme.co.secondary98};
    padding: ${theme.sz.s4};
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s3};
    width: 100%;
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
  `,
);

export const DescriptionSection = styled.div(() => css``);

export const SummarySection = styled.div(
  ({ theme }) => css`
    background-color: ${theme.co.neutral99};
    border-radius: ${theme.bo.small};
    padding: ${theme.sz.s1};
    display: flex;
    gap: ${theme.sz.s2};

    ${theme.typography.heading.desktop.xxxs};
  `,
);

export const GrowthLevelIndicator = styled(_GrowthLevelIndicator)(
  ({ theme }) => css`
    padding: ${theme.sz.s1};
  `,
);

export const SummaryText = styled.div(
  () => css`
    align-self: center;
    flex-grow: 1;
  `,
);

export const SummaryNumber = styled.div(
  ({ theme }) => css`
    align-self: center;
    min-width: ${theme.sz.s6};
  `,
);
